import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Approach", href: "#approach" },
  { label: "Services", href: "#services" },
  { label: "Outcomes", href: "#outcomes" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-brand-bg/85 backdrop-blur-md border-b border-brand-primary/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="/logo.jpg"
            alt="NeuroNest Growth and Development Clinic"
            className="h-11 w-auto object-contain group-hover:scale-[1.03] transition-transform duration-300"
          />
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-brand-ink/70 hover:text-brand-primary transition-colors duration-300 relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-brand-secondary after:transition-all after:duration-300 hover:after:w-full"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          data-testid="nav-cta-book"
          className="rounded-full bg-brand-primary text-brand-bg px-6 py-2.5 text-sm hover:bg-[#1f332a] transition-colors duration-300"
        >
          Book a visit
        </a>
      </nav>
    </motion.header>
  );
};
